import { render, staticRenderFns } from "./DictionaryFormModal.vue?vue&type=template&id=70f79b9a&"
import script from "./DictionaryFormModal.vue?vue&type=script&lang=js&"
export * from "./DictionaryFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports